import ShelfApi from "~/utils/ShelfApi.js"
import {push} from "react-router-redux"

import {SET_CURRENT_USER} from "./types"
import {toBoolean} from "../utils"

export function validateResetPasswordToken(data) {
  return dispatch =>
    ShelfApi.get(
      `auth/password/edit?reset_password_token=${data.reset_password_token}&redirect_url=${data.redirect_url}`,
      data
    ).then(res => {
      console.log(res)
    })
}

export function resetPassword(data) {
  return dispatch =>
    ShelfApi.put("/auth/password", data).then(res => {
      console.log(res)
    })
}

export function signup(data) {
  return dispatch =>
    ShelfApi.post("/auth", data).then(res => {
      console.log(res)
    })
}

function setCurrentUser(user) {
  return {
    type: SET_CURRENT_USER,
    user
  }
}

const keys = [
  "accessToken",
  "client",
  "expiry",
  "subdomain",
  "uid",
  "admin",
  "superAdmin",
  "tenantAdmin",
  "settings",
  "mayUseCart"
]

export function setCurrentUserFromLocalStorage() {
  return dispatch => {
    let settingsParsed
    try {
      settingsParsed = JSON.parse(localStorage.settings)
    } catch (error) {
      settingsParsed = false
    }

    const expiryTimestamp = Number(localStorage.expiry)
    const tokenExpired =
      !expiryTimestamp ||
      Number.isNaN(expiryTimestamp) ||
      expiryTimestamp <= Math.floor(Date.now() / 1000)

    if (tokenExpired) {
      keys.forEach(key => localStorage.removeItem(key))
      ShelfApi.removeConfiguration()
      dispatch(setCurrentUser({}))
      return
    }

    if (settingsParsed) {
      dispatch(
        setCurrentUser({
          uid: localStorage.uid,
          client: localStorage.client,
          expiry: localStorage.expiry,
          subdomain: localStorage.subdomain,
          admin: toBoolean(localStorage.admin),
          superAdmin: toBoolean(localStorage.superAdmin),
          tenantAdmin: toBoolean(localStorage.tenantAdmin),
          settings: settingsParsed,
          mayUseCart: toBoolean(localStorage.mayUseCart)
        })
      )
    } else {
      logout()
    }
  }
}

export async function setCurrentRegion(region) {
  await localStorage.setItem("region", region)
  ShelfApi.loadConfiguration()
}

export function login(data) {
  return dispatch =>
    ShelfApi.post("/auth/sign_in", data).then(res => {
      const responseData = {
        accessToken: res.headers["access-token"],
        client: res.headers["client"],
        expiry: res.headers["expiry"],
        uid: res.headers["uid"],
        subdomain: res.data.data["subdomain"],
        admin: res.data.data["admin"],
        superAdmin: res.data.data["super_admin"],
        tenantAdmin: res.data.data["tenant_admin"],
        settings: JSON.stringify(res.data.data["settings"]),
        mayUseCart: res.data.data["may_use_cart"]
      }

      Object.entries(responseData).forEach(([key, value]) =>
        localStorage.setItem(key, value)
      )

      ShelfApi.loadConfiguration()
      dispatch(setCurrentUserFromLocalStorage())

      // const afterLoginPath = toBoolean(responseData.superAdmin)
      //   ? "/tenants"
      //   : "/"
      const afterLoginPath = "/"
      dispatch(push(afterLoginPath))
    })
}

export function logout() {
  window.location.reload(false)
  return dispatch => {
    keys.forEach(key => localStorage.removeItem(key))

    ShelfApi.removeConfiguration()
    dispatch(setCurrentUser({}))

    dispatch(push("/"))
  }
}



// WEBPACK FOOTER //
// ./src/actions/authActions.js